import React, { useEffect, useState } from "react";
import { AuthServices } from "../services/AuthServices";
import WhyPartner from "../components/WhyPartner";
import Contact from "../components/Contact";
import LandingHero from "../components/LandingHero";
import AuthChoice from "../components/AuthChoice";

const LandingPage = ({ loginForm, setShowLoginForm }) => {
  const [loading, setLoading] = useState(false);

  const handleAlreadyPartner = () => {
    setShowLoginForm(!loginForm);
  };

  const clearApplication = async () => {
    localStorage.clear();
    setShowLoginForm(false);
    setLoading(false);
    await AuthServices.clearToken();
  };

  useEffect(() => {
    clearApplication();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner" />
          <p>Creating your account...</p>
        </div>
      )}

      <section className="hero sign-up-form">
        <LandingHero />
        <AuthChoice
          loginForm={loginForm}
          handleAlreadyPartner={handleAlreadyPartner}
        />
      </section>
      <WhyPartner />
      <Contact />
    </div>
  );
};

export default LandingPage;
